"use strict";

module.exports = function () {
  this.page = 1;
  return Math.ceil(this.count / this.limit);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/total-pages.js
// module id = 654
// module chunks = 1